export default{
  mounted: mounted,
  computed: {
    $body: $body
  },
  destroyed: destroyed
}

function mounted(){
  this.$body.classList.add('no-footer');
}

function destroyed(){
  this.$body.classList.remove('no-footer');
}

function $body(){
  return document.querySelector('body');
}